import React, { useEffect } from 'react';
import ScrollToTop from '../../../shared/utils/scrollToTop';
import { ComponentLoader, InPageAlert, SectionPage } from '@snsw/react-component-library';

import { FeeSummary } from '@onegov/react-component-library';
import { useDispatch, useSelector } from 'react-redux';
import { PagePath } from 'shared/constants/pagePath';
import { getPlantDesignFees } from '../../redux/plantDesignFeesSlice';
import { PasswordlessContinueSaveExitButtons } from 'shared/components/formNavigationButtons/PasswordlessContinueSaveExitButtons';
import { LoadingStates } from 'shared/constants/loadingStates';
import { initPlantDesignPayment } from 'plantDesign/redux/plantDesignPaymentSlice';
import { useNavigate } from 'react-router-dom';
import { PlantDesignConstants } from 'plantDesign/constants/plantDesignConstants';

export const PlantDesignFees = (props) => {
  ScrollToTop();

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const fees = useSelector((state) => state.plantDesignFees);
  const payment = useSelector((state) => state.plantDesignPayment);
  const { paymentReference, paymentRedirectUrl } = payment;

  useEffect(() => {
    dispatch(getPlantDesignFees());
  }, [dispatch]);

  const onContinueClick = () => {
    if (fees.status === LoadingStates.Succeeded) {
      dispatch(initPlantDesignPayment());
    }
  };

  useEffect(() => {
    if (paymentReference && paymentRedirectUrl) {
      window.location.href = `${paymentRedirectUrl}${paymentReference}`;
    }
  }, [paymentReference, paymentRedirectUrl]);

  const onBackClick = () => {
    navigate(PagePath.plantDesignDeclaration);
  };

  const mapFeeComponents = (data = {}) => {
    const feeComponents = [
      {
        feeName: 'Plant Design registration fee',
        value: data.totalFeeProcessingAmt,
      },
    ];

    return feeComponents;
  };

  return (
    <SectionPage>
      <InPageAlert
        variant="info"
        title="You’ll be taken to a secure platform provided by Service NSW to complete your payment and submit your application."
        headingLevel="h4"
      />

      <div style={{ marginTop: 32, marginBottom: 64 }}>
        <FeeSummary
          title="Fee breakdown"
          isLoading={fees.status === LoadingStates.Loading}
          feeComponents={fees?.data && mapFeeComponents(fees.data)}
          netFeeAmount={fees.data?.totalFeeProcessingAmt}
        />
      </div>

      <PasswordlessContinueSaveExitButtons
        onContinueClick={onContinueClick}
        onBackClick={onBackClick}
        licenceType={PlantDesignConstants.licenceType}
      />

      {(payment.status === LoadingStates.Loading || payment.status === LoadingStates.Succeeded) && <ComponentLoader />}
    </SectionPage>
  );
};
